import React, { useMemo } from 'react';

// HELPERS
import { useReport } from '../helpers/getReportData';

// GLOBAL PARTS
import Table from 'parts/table/Table';

// STYLES
import styles from './dataTable.module.scss';

// MAIN COMPONENT
const DataTable = () => {
  // HOOKS
  const { report_data } = useReport();

  // Allow for report_data = null
  const header = useMemo(() => report_data?.header || [], [report_data]);
  const data = useMemo(() => report_data?.data || [], [report_data]);

  // MEMOS
  const columns = useMemo(
    () =>
      header.map(column => ({
        key: column,
        label: column,
        size: 'md'
      })),
    [header]
  );

  // TODO: Fine tune this logic
  const mobilePreviewKey = Object.keys(data?.[0] || [])?.[0];

  // RENDER
  return !data?.length ? null : (
    <Table
      className={styles.table}
      columns={columns}
      result={data}
      sortable={false}
      autoSizeHeight={false}
      mobilePreviewKeys={mobilePreviewKey ? [mobilePreviewKey] : undefined}
      rowHeight={38}
    />
  );
};

// EXPORT
export default DataTable;
